// tracking/TrackingContext.js
import React, { createContext, useContext } from "react";

const noop = () => {};
export const TrackingContext = createContext({ trackEvent: noop });
export const useTracking = () => useContext(TrackingContext);
